<ts-pipeline-editor
  [pipeline]="data.pipeline"
  [methodType]="data.methodType"
  [embedInCard]="false"
  [redirectBack]="false"
  (submitted)="closeDialog($event)"
>
</ts-pipeline-editor>
